import { Component, OnDestroy, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {

  mapComponent;
  collectionId;
  pluginUrl;

  constructor(private elementRef: ElementRef) {
    this.collectionId = this.elementRef.nativeElement.getAttribute('collectionId');
    this.mapComponent = this.elementRef.nativeElement.getAttribute('mapComponent');
    this.pluginUrl = this.elementRef.nativeElement.getAttribute('pluginUrl');
  }

  ngOnDestroy() {

  }
}
